import React from 'react';
import { UsersIcon, StarIcon, HeartIcon, ShieldIcon, FlameIcon, TargetIcon, TrophyIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
import { ValueBadge } from './ValueBadge';
import { Button } from './Button';
const values = [{
  name: 'Respect',
  description: 'For ourselves and others',
  icon: <UsersIcon className="w-7 h-7" data-id="element-269" />
}, {
  name: 'Inspiration',
  description: 'Leading by example',
  icon: <StarIcon className="w-7 h-7" data-id="element-270" />
}, {
  name: 'Friendship',
  description: 'Building lasting bonds',
  icon: <HeartIcon className="w-7 h-7" data-id="element-271" />
}, {
  name: 'Equality',
  description: 'Sport for everyone',
  icon: <ShieldIcon className="w-7 h-7" data-id="element-272" />
}, {
  name: 'Courage',
  description: 'Trying new things',
  icon: <FlameIcon className="w-7 h-7" data-id="element-273" />
}, {
  name: 'Determination',
  description: 'Never giving up',
  icon: <TargetIcon className="w-7 h-7" data-id="element-274" />
}, {
  name: 'Excellence',
  description: 'Being our best',
  icon: <TrophyIcon className="w-7 h-7" data-id="element-275" />
}];
interface ValuesSectionProps {
  ctaLabel?: string;
  ctaHref?: string;
}
export function ValuesSection({
  ctaLabel = 'Discover Our Medals Programme',
  ctaHref = '/medals'
}: ValuesSectionProps) {
  return <section data-component="COMP-13-ValuesSection" className="py-24 bg-brand-blue" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <SectionHeader eyebrow="The Olympic Way" title="Built on Olympic Values" description="More than just sports skills. We embed the seven Olympic and Paralympic values into every session we deliver." light={true} data-id="element-278" />

        <div className="flex flex-wrap justify-center gap-8 md:gap-10 mb-16" data-id="element-279">
          {values.map((value, index) => <ValueBadge key={index} icon={value.icon} name={value.name} description={value.description} index={index} data-id="element-280" />)}
        </div>

        <div className="text-center" data-id="element-281">
          <Button variant="gold" size="lg" href={ctaHref} data-id="element-282">
            {ctaLabel}
          </Button>
        </div>
      </div>
    </section>;
}